define(['angular', 'angular-resource', '../models/site'], function (angular) {
    return angular
        .module('siteServices', ['ngResource', 'siteModels'])
        .factory('Site', [
            '$resource',
            '$rootScope',
            'SiteModel',
            function ($resource, $rootScope, SiteModel) {
                var resource = $resource(
                    $rootScope.Routing.generate('get_all_sites', {
                        _format: 'json',
                    }),
                    [],
                    {
                        checkEmailCredentials: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'check_email_credentials',
                                    {
                                        _format: 'json',
                                    }
                                )
                            ),
                            method: 'GET',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse site as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new SiteModel(modelData);
                            },
                        },
                        delete: {
                            method: 'DELETE',
                            params: { id: '@id' },
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('delete_site', {
                                    site: ':id',
                                    _format: 'json',
                                })
                            ),
                        },
                        get: {
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('get_site', {
                                    _format: 'json',
                                })
                            ),
                            method: 'GET',
                            isArray: false,
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse site as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new SiteModel(modelData);
                            },
                        },
                        query: {
                            method: 'GET',
                            isArray: true,
                            transformResponse: function (data) {
                                var modelData = [];
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse sites as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                for (i in modelData) {
                                    modelData[i] = new SiteModel(modelData[i]);
                                }
                                return modelData;
                            },
                        },
                        update: {
                            method: 'PUT',
                            isArray: false,
                            url: decodeURIComponent(
                                $rootScope.Routing.generate('update_site', {
                                    _format: 'json',
                                })
                            ),
                            transformResponse: function (data) {
                                var modelData = {};
                                try {
                                    modelData = JSON.parse(data);
                                } catch (e) {
                                    if (typeof Raven != 'undefined' && Raven) {
                                        Raven.captureException(e);
                                        Raven.captureException(
                                            new Error(
                                                'Cannot parse site as json: ' +
                                                    data
                                            )
                                        );
                                    }
                                }
                                return new SiteModel(modelData);
                            },
                        },
                        disableAVMCampaigns: {
                            method: 'GET',
                            params: { id: '@id' },
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'disable_avm_campaigns',
                                    { site: ':id', _format: 'json' }
                                )
                            ),
                        },
                        disableEmailCampaigns: {
                            method: 'GET',
                            params: { id: '@id' },
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'disable_email_campaigns',
                                    { site: ':id', _format: 'json' }
                                )
                            ),
                        },
                        disableSmsCampaigns: {
                            method: 'GET',
                            params: { id: '@id' },
                            url: decodeURIComponent(
                                $rootScope.Routing.generate(
                                    'disable_sms_campaigns',
                                    { site: ':id', _format: 'json' }
                                )
                            ),
                        },
                    }
                );

                var site = false;
                var allSites = false;
                return {
                    getSite: function (reload, callback) {
                        if (!site || reload) {
                            site = resource.get();
                        }
                        if (typeof callback == 'function') {
                            site.$promise.then(callback);
                        }
                        return site;
                    },
                    getAllSites: function (reload, callback) {
                        if (!allSites) {
                            allSites = resource.query();
                        } else if (reload) {
                            resource.query().$promise.then(function (sites) {
                                allSites.splice(0, allSites.length);
                                angular.forEach(sites, function (site) {
                                    allSites.push(site);
                                });
                            });
                        }
                        if (typeof callback == 'function') {
                            allSites.$promise.then(callback);
                        }

                        return allSites;
                    },
                };
            },
        ]);
});
